module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-card', {
    ref: "card",
    staticClass: "card-border",
    style: ({
      height: _vm.cardHeight + 'px'
    }),
    attrs: {
      "id": "report",
      "body-style": {
        padding: 0
      }
    }
  }, [_c('div', {
    staticClass: "clearfix",
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('span', {
    staticClass: "title",
    staticStyle: {
      "line-height": "36px"
    }
  }, [_vm._v(_vm._s(_vm.$t('REPORT')))]), _vm._v(" "), _c('el-dropdown', {
    attrs: {
      "hide-on-click": _vm.hideOnClick
    },
    on: {
      "command": _vm.pushDataColumns
    }
  }, [_c('el-button', {
    staticClass: "first-radius",
    attrs: {
      "type": "primary"
    }
  }, [_vm._v("\n                    " + _vm._s(_vm.$t('GETREPORT'))), _c('i', {
    staticClass: "el-icon-caret-bottom el-icon--right"
  })]), _vm._v(" "), _c('el-dropdown-menu', {
    attrs: {
      "slot": "dropdown"
    },
    slot: "dropdown"
  }, [_c('el-dropdown-item', [_c('div', [_c('el-switch', {
    attrs: {
      "width": 100,
      "on-text": _vm.$t('GROUPEDBY'),
      "off-text": _vm.$t('GROUPBY')
    },
    model: {
      value: (_vm.groupBy[_vm.filterKey]),
      callback: function($$v) {
        _vm.$set(_vm.groupBy, _vm.filterKey, $$v)
      },
      expression: "groupBy[filterKey]"
    }
  })], 1)]), _vm._v(" "), _c('el-dropdown-item', {
    attrs: {
      "divided": ""
    }
  }, [_c('el-button', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.selectAll
    }
  }, [_vm._v(_vm._s(_vm.SelectAll[_vm.filterKey] ? _vm.$t('SELECTALL') : _vm.$t('DESELECTALL')))])], 1), _vm._v(" "), _c('el-dropdown-item', {
    attrs: {
      "divided": ""
    }
  }), _vm._v(" "), _vm._l(((!_vm.groupBy[_vm.filterKey] ? _vm.makeList(_vm.dataColumns[_vm.filterKey], true) : _vm.makeList(_vm.countDataColumns[_vm.filterKey], true, true))), function(item, key) {
    return _c('el-dropdown-item', {
      key: key,
      attrs: {
        "command": key
      }
    }, [_vm._v(_vm._s(item)), (_vm.DataColumn[_vm.filterKey].indexOf(key) >= 0) ? _c('span', {
      staticClass: "fa fa-check pull-right"
    }) : _vm._e()])
  }), _vm._v(" "), _c('el-dropdown-item', {
    attrs: {
      "divided": ""
    }
  }, [_c('el-button', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "type": "primary",
      "disabled": _vm.onClickStatus()
    },
    on: {
      "click": _vm.search
    }
  }, [_vm._v(_vm._s(_vm.$t('SHOW')))])], 1)], 2)], 1), _vm._v(" "), _c('el-button', {
    staticClass: "second-radius",
    staticStyle: {
      "border-left-color": "rgb(175, 185, 195)"
    },
    attrs: {
      "type": "primary",
      "disabled": _vm.filteredData[_vm.filterKey].length == 0 && _vm.filteredCountData[_vm.filterKey].length == 0
    },
    on: {
      "click": _vm.exportToCSV
    }
  }, [_c('i', {
    staticClass: "fa fa-download"
  }), _vm._v(" " + _vm._s(_vm.$t('EXPORT')))])], 1), _vm._v(" "), _c('el-tabs', {
    attrs: {
      "type": "border-card"
    },
    on: {
      "tab-click": _vm.changeFilterKey
    },
    model: {
      value: (_vm.filterKey),
      callback: function($$v) {
        _vm.filterKey = $$v
      },
      expression: "filterKey"
    }
  }, [_c('el-tab-pane', {
    attrs: {
      "label": _vm.$t('TRIPS'),
      "name": "Trip"
    }
  }, [_vm._l((_vm.DataColumn[_vm.filterKey]), function(item, index) {
    return _c('div', {
      key: index
    })
  }), _vm._v(" "), _c('el-row', {
    staticClass: "filters"
  }, [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-form', {
    ref: "form",
    attrs: {
      "model": _vm.filters[_vm.filterKey]
    }
  }, [_c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('el-form-item', [_c('el-select', {
    attrs: {
      "placeholder": _vm.$t('SELECTROUTE'),
      "filterable": "",
      "clearable": _vm.filters[_vm.filterKey].TourID ? true : false
    },
    on: {
      "change": function($event) {
        _vm.pushFilterBy('TourID', 'Route', 1, false, $event)
      }
    },
    model: {
      value: (_vm.filters[_vm.filterKey].TourID),
      callback: function($$v) {
        _vm.$set(_vm.filters[_vm.filterKey], "TourID", $$v)
      },
      expression: "filters[filterKey].TourID"
    }
  }, _vm._l((_vm.routes), function(route, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "label": route.TourName,
        "value": route.TourID
      }
    })
  }))], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('el-form-item', [_c('el-select', {
    attrs: {
      "placeholder": _vm.$t('SELECTDIRECTION'),
      "clearable": _vm.filters[_vm.filterKey].Direction ? true : false
    },
    on: {
      "change": function($event) {
        _vm.pushFilterBy('Direction', 'Direction', 1, false, $event)
      }
    },
    model: {
      value: (_vm.filters[_vm.filterKey].Direction),
      callback: function($$v) {
        _vm.$set(_vm.filters[_vm.filterKey], "Direction", $$v)
      },
      expression: "filters[filterKey].Direction"
    }
  }, [_c('el-option', {
    attrs: {
      "value": "1",
      "label": _vm.$t('HOMETOSCHOOL')
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "value": "2",
      "label": _vm.$t('SCHOOLTOHOME')
    }
  })], 1)], 1)], 1), _vm._v(" "), (_vm.filterKey === 'Trip') ? _c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('el-form-item', [_c('el-date-picker', {
    attrs: {
      "picker-options": _vm.pickerOption,
      "type": "daterange",
      "placeholder": _vm.$t('PICKARANGE')
    },
    on: {
      "change": function($event) {
        _vm.pushFilterBy('dateRange', 'DateRange', 2, false, $event)
      }
    },
    model: {
      value: (_vm.filters[_vm.filterKey].dateRange),
      callback: function($$v) {
        _vm.$set(_vm.filters[_vm.filterKey], "dateRange", $$v)
      },
      expression: "filters[filterKey].dateRange"
    }
  })], 1)], 1) : _vm._e()], 1)], 1)], 1)], 1), _vm._v(" "), (_vm.filterKey === 'Trip') ? _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    style: ({
      opacity: _vm.opacity[_vm.filterKey],
      height: _vm.loadHeight + 'px'
    }),
    attrs: {
      "id": "load-panel",
      "element-loading-text": _vm.$t('LOADING')
    }
  }, [_c('el-table', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.groupBy[_vm.filterKey] && _vm.CountDataColumn[_vm.filterKey].length == 0),
      expression: "!groupBy[filterKey] && CountDataColumn[filterKey].length == 0"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.filteredData[_vm.filterKey][_vm.currentPage[_vm.filterKey] - 1],
      "height": _vm.tableHeight,
      "highlight-current-row": "",
      "empty-text": _vm.$t('NODATATOSHOW'),
      "stripe": ""
    }
  }, _vm._l((_vm.makeList(_vm.dataColumns[_vm.filterKey], true)), function(item, key) {
    return (_vm.DataColumn[_vm.filterKey].indexOf(key) >= 0) ? _c('el-table-column', {
      key: key,
      attrs: {
        "label": item,
        "align": "left"
      },
      scopedSlots: _vm._u([{
        key: "default",
        fn: function(scope) {
          return [_vm._v(_vm._s(scope.row[key]))]
        }
      }])
    }) : _vm._e()
  })), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.groupBy[_vm.filterKey] || _vm.CountDataColumn[_vm.filterKey].length > 0),
      expression: "groupBy[filterKey] || CountDataColumn[filterKey].length > 0"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.filteredCountData[_vm.filterKey][_vm.currentPage[_vm.filterKey] - 1],
      "highlight-current-row": "",
      "empty-text": _vm.$t('NODATATOSHOW'),
      "height": _vm.tableHeight,
      "stripe": ""
    }
  }, [_vm._l((_vm.makeList(_vm.countDataColumns[_vm.filterKey], true, true)), function(item, key) {
    return (!_vm.groupBy[_vm.filterKey] && (_vm.CountDataColumn[_vm.filterKey].indexOf(key) >= 0 || key == 'Count')) ? _c('el-table-column', {
      key: key,
      attrs: {
        "label": item,
        "align": "left"
      },
      scopedSlots: _vm._u([{
        key: "default",
        fn: function(scope) {
          return [_vm._v(_vm._s(scope.row[key]))]
        }
      }])
    }) : _vm._e()
  }), _vm._v(" "), _vm._l((_vm.makeList(_vm.countDataColumns[_vm.filterKey], true, true)), function(item, key) {
    return (_vm.groupBy[_vm.filterKey] && _vm.DataColumn[_vm.filterKey].indexOf(key) >= 0) ? _c('el-table-column', {
      key: key,
      attrs: {
        "label": item,
        "align": "left"
      },
      scopedSlots: _vm._u([{
        key: "default",
        fn: function(scope) {
          return [_vm._v(_vm._s(scope.row[key]))]
        }
      }])
    }) : _vm._e()
  })], 2), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.checkAllConditions()),
      expression: "checkAllConditions()"
    }],
    staticClass: "footer"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.filteredData[_vm.filterKey].length != 0),
      expression: "filteredData[filterKey].length!=0"
    }],
    staticStyle: {
      "float": "left"
    }
  }, [_c('el-select', {
    ref: "countsBy",
    staticClass: "autoWidth",
    attrs: {
      "size": "small",
      "disabled": !(!_vm.groupBy[_vm.filterKey] && _vm.filteredData[_vm.filterKey].length != 0),
      "placeholder": _vm.$t('UNIQUECOUNTBY'),
      "multiple": ""
    },
    on: {
      "change": _vm.uniqueColumnsCount
    },
    model: {
      value: (_vm.CountDataColumn[_vm.filterKey]),
      callback: function($$v) {
        _vm.$set(_vm.CountDataColumn, _vm.filterKey, $$v)
      },
      expression: "CountDataColumn[filterKey]"
    }
  }, _vm._l((_vm.makeList(_vm.countDataColumns[_vm.filterKey], true, true)), function(item, key) {
    return (_vm.DataColumn[_vm.filterKey].indexOf(key) >= 0) ? _c('el-option', {
      key: key,
      attrs: {
        "label": item,
        "value": key
      }
    }) : _vm._e()
  }))], 1), _vm._v(" "), _c('el-pagination', {
    attrs: {
      "current-page": _vm.currentPage[_vm.filterKey],
      "page-sizes": [20, 30, 50, 70],
      "page-size": _vm.limit[_vm.filterKey],
      "layout": "total, sizes, prev, pager, next",
      "total": _vm.total[_vm.filterKey],
      "align": "right"
    },
    on: {
      "size-change": _vm.handleSizeChange,
      "current-change": _vm.handleCurrentChange
    }
  })], 1)], 1) : _vm._e()], 2), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": _vm.$tc('BUS', 1),
      "name": "Bus"
    },
    on: {
      "tab-click": _vm.changeFilterKey
    }
  }, [_vm._l((_vm.DataColumn[_vm.filterKey]), function(item, index) {
    return _c('div', {
      key: index
    })
  }), _vm._v(" "), _c('el-row', {
    staticClass: "filters",
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-form', {
    ref: "form",
    attrs: {
      "id": "busFilters",
      "model": _vm.filters[_vm.filterKey]
    }
  }, [_c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('el-form-item', [_c('div', {
    staticClass: "el-input el-input-group el-input-group--prepend"
  }, [_c('div', {
    staticClass: "el-input-group__prepend buses"
  }, [_c('el-input', {
    staticClass: "need-radius",
    attrs: {
      "type": "number",
      "placeholder": _vm.$t('MINCAPACITY')
    },
    on: {
      "change": function($event) {
        _vm.pushFilterBy(['minCapacity', 'maxCapacity'], 'Capacity', 1, false, $event)
      }
    },
    model: {
      value: (_vm.filters[_vm.filterKey].minCapacity),
      callback: function($$v) {
        _vm.$set(_vm.filters[_vm.filterKey], "minCapacity", $$v)
      },
      expression: "filters[filterKey].minCapacity"
    }
  })], 1), _vm._v(" "), _c('el-input', {
    attrs: {
      "type": "number",
      "placeholder": _vm.$t('MAXCAPACITY')
    },
    on: {
      "change": function($event) {
        _vm.pushFilterBy(['minCapacity', 'maxCapacity'], 'Capacity', 1, false, $event)
      }
    },
    model: {
      value: (_vm.filters[_vm.filterKey].maxCapacity),
      callback: function($$v) {
        _vm.$set(_vm.filters[_vm.filterKey], "maxCapacity", $$v)
      },
      expression: "filters[filterKey].maxCapacity"
    }
  })], 1)])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('el-form-item', [_c('div', {
    staticClass: "el-input el-input-group el-input-group--prepend"
  }, [_c('div', {
    staticClass: "el-input-group__prepend buses"
  }, [_c('el-select', {
    attrs: {
      "placeholder": _vm.$t('MINYEAR'),
      "clearable": _vm.filters[_vm.filterKey].minYear ? true : false
    },
    on: {
      "change": function($event) {
        _vm.pushFilterBy(['minYear', 'maxYear'], 'Year', 1, true, $event)
      }
    },
    model: {
      value: (_vm.filters[_vm.filterKey].minYear),
      callback: function($$v) {
        _vm.$set(_vm.filters[_vm.filterKey], "minYear", $$v)
      },
      expression: "filters[filterKey].minYear"
    }
  }, _vm._l((_vm.range(_vm.initialYear, _vm.lastYear)), function(val, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "label": val,
        "value": val
      }
    })
  }))], 1), _vm._v(" "), _c('el-select', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "placeholder": _vm.$t('MAXYEAR'),
      "clearable": _vm.filters[_vm.filterKey].maxYear ? true : false,
      "disabled": _vm.filters[_vm.filterKey].minYear == null
    },
    on: {
      "change": function($event) {
        _vm.pushFilterBy(['minYear', 'maxYear'], 'Year', 1, false, $event)
      }
    },
    model: {
      value: (_vm.filters[_vm.filterKey].maxYear),
      callback: function($$v) {
        _vm.$set(_vm.filters[_vm.filterKey], "maxYear", $$v)
      },
      expression: "filters[filterKey].maxYear"
    }
  }, _vm._l((_vm.range(_vm.initialYear, _vm.lastYear)), function(val, index) {
    return (val > _vm.filters[_vm.filterKey].minYear) ? _c('el-option', {
      key: index,
      attrs: {
        "label": val,
        "value": val
      }
    }) : _vm._e()
  }))], 1)])], 1), _vm._v(" "), (_vm.filterKey === 'Bus') ? _c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_c('el-form-item', [_c('el-date-picker', {
    attrs: {
      "popper-class": "el-date-editor",
      "type": "date",
      "placeholder": _vm.$t('PICKADATE')
    },
    on: {
      "change": function($event) {
        _vm.pushFilterBy('date', 'ExpirationDate', 3, false, $event)
      }
    },
    model: {
      value: (_vm.filters[_vm.filterKey].date),
      callback: function($$v) {
        _vm.$set(_vm.filters[_vm.filterKey], "date", $$v)
      },
      expression: "filters[filterKey].date"
    }
  })], 1)], 1) : _vm._e()], 1)], 1)], 1)], 1), _vm._v(" "), (_vm.filterKey === 'Bus') ? _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    style: ({
      opacity: _vm.opacity[_vm.filterKey],
      height: _vm.loadHeight + 'px'
    }),
    attrs: {
      "id": "load-panel",
      "element-loading-text": _vm.$t('LOADING')
    }
  }, [_c('el-table', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.groupBy[_vm.filterKey] && _vm.CountDataColumn[_vm.filterKey].length == 0),
      expression: "!groupBy[filterKey] && CountDataColumn[filterKey].length == 0"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.filteredData[_vm.filterKey][_vm.currentPage[_vm.filterKey] - 1],
      "height": _vm.tableHeight,
      "highlight-current-row": "",
      "empty-text": _vm.$t('NODATATOSHOW'),
      "stripe": ""
    }
  }, _vm._l((_vm.makeList(_vm.dataColumns[_vm.filterKey], true)), function(item, key) {
    return (_vm.DataColumn[_vm.filterKey].indexOf(key) >= 0) ? _c('el-table-column', {
      key: key,
      attrs: {
        "label": item,
        "align": "left"
      },
      scopedSlots: _vm._u([{
        key: "default",
        fn: function(scope) {
          return [_vm._v(_vm._s(scope.row[key]))]
        }
      }])
    }) : _vm._e()
  })), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.groupBy[_vm.filterKey] || _vm.CountDataColumn[_vm.filterKey].length > 0),
      expression: "groupBy[filterKey] || CountDataColumn[filterKey].length > 0"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.filteredCountData[_vm.filterKey][_vm.currentPage[_vm.filterKey] - 1],
      "highlight-current-row": "",
      "empty-text": _vm.$t('NODATATOSHOW'),
      "height": _vm.tableHeight,
      "stripe": ""
    }
  }, [_vm._l((_vm.makeList(_vm.countDataColumns[_vm.filterKey], true, true)), function(item, key) {
    return (!_vm.groupBy[_vm.filterKey] && (_vm.CountDataColumn[_vm.filterKey].indexOf(key) >= 0 || key == 'Count')) ? _c('el-table-column', {
      key: key,
      attrs: {
        "label": item,
        "align": "left"
      },
      scopedSlots: _vm._u([{
        key: "default",
        fn: function(scope) {
          return [_vm._v(_vm._s(scope.row[key]))]
        }
      }])
    }) : _vm._e()
  }), _vm._v(" "), _vm._l((_vm.makeList(_vm.countDataColumns[_vm.filterKey], true, true)), function(item, key) {
    return (_vm.groupBy[_vm.filterKey] && _vm.DataColumn[_vm.filterKey].indexOf(key) >= 0) ? _c('el-table-column', {
      key: key,
      attrs: {
        "label": item,
        "align": "left"
      },
      scopedSlots: _vm._u([{
        key: "default",
        fn: function(scope) {
          return [_vm._v(_vm._s(scope.row[key]))]
        }
      }])
    }) : _vm._e()
  })], 2), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.checkAllConditions()),
      expression: "checkAllConditions()"
    }],
    staticClass: "footer"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.filteredData[_vm.filterKey].length != 0),
      expression: "filteredData[filterKey].length!=0"
    }],
    staticStyle: {
      "float": "left"
    }
  }, [_c('el-select', {
    ref: "countsBy",
    staticClass: "autoWidth",
    attrs: {
      "size": "small",
      "disabled": !(!_vm.groupBy[_vm.filterKey] && _vm.filteredData[_vm.filterKey].length != 0),
      "placeholder": _vm.$t('UNIQUECOUNTBY'),
      "multiple": ""
    },
    on: {
      "change": _vm.uniqueColumnsCount
    },
    model: {
      value: (_vm.CountDataColumn[_vm.filterKey]),
      callback: function($$v) {
        _vm.$set(_vm.CountDataColumn, _vm.filterKey, $$v)
      },
      expression: "CountDataColumn[filterKey]"
    }
  }, _vm._l((_vm.makeList(_vm.countDataColumns[_vm.filterKey], true, true)), function(item, key) {
    return (_vm.DataColumn[_vm.filterKey].indexOf(key) >= 0) ? _c('el-option', {
      key: key,
      attrs: {
        "label": item,
        "value": key
      }
    }) : _vm._e()
  }))], 1), _vm._v(" "), _c('el-pagination', {
    attrs: {
      "current-page": _vm.currentPage[_vm.filterKey],
      "page-sizes": [20, 30, 50, 70],
      "page-size": _vm.limit[_vm.filterKey],
      "layout": "total, sizes, prev, pager, next",
      "total": _vm.total[_vm.filterKey],
      "align": "right"
    },
    on: {
      "size-change": _vm.handleSizeChange,
      "current-change": _vm.handleCurrentChange
    }
  })], 1)], 1) : _vm._e()], 2), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": _vm.$tc('SUPERVISOR', 1),
      "name": "Supervisor"
    }
  }, [_vm._l((_vm.DataColumn[_vm.filterKey]), function(item, index) {
    return _c('div', {
      key: index
    })
  }), _vm._v(" "), _c('el-row', {
    staticClass: "filters",
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": _vm.$t('FILTERBYSUPERVISOR'),
      "clearable": _vm.filterBy[_vm.filterKey][0] ? true : false
    },
    on: {
      "change": _vm.resetFiltersValue
    },
    model: {
      value: (_vm.filterBy[_vm.filterKey][0]),
      callback: function($$v) {
        _vm.$set(_vm.filterBy[_vm.filterKey], 0, $$v)
      },
      expression: "filterBy[filterKey][0]"
    }
  }, _vm._l((_vm.makeList(_vm.mainTypes[_vm.filterKey])), function(item, key) {
    return _c('el-option', {
      key: key,
      attrs: {
        "label": item,
        "value": key
      }
    })
  }))], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 14
    }
  }, [_c('el-form', {
    ref: "form",
    attrs: {
      "id": "supervisorFilters",
      "model": _vm.filters[_vm.filterKey]
    }
  }, [_c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.checkIndex('Nationality')),
      expression: "checkIndex('Nationality')"
    }],
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', [_c('div', {
    staticClass: "el-input el-input-group el-input-group--prepend"
  }, [_c('a', {
    staticClass: "el-input-group__prepend el-button el-icon-close",
    on: {
      "click": function($event) {
        _vm.removeIndex('Nationality', true)
      }
    }
  }), _vm._v(" "), _c('el-select', {
    attrs: {
      "placeholder": _vm.$t('SELECTNATIONALITY'),
      "filterable": "",
      "clearable": _vm.filters[_vm.filterKey].Nationality ? true : false
    },
    model: {
      value: (_vm.filters[_vm.filterKey].Nationality),
      callback: function($$v) {
        _vm.$set(_vm.filters[_vm.filterKey], "Nationality", $$v)
      },
      expression: "filters[filterKey].Nationality"
    }
  }, _vm._l((_vm.$countries), function(item, key) {
    return _c('el-option', {
      key: key,
      attrs: {
        "label": item,
        "value": key
      }
    })
  }))], 1)])], 1), _vm._v(" "), _c('el-col', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.checkIndex('Route')),
      expression: "checkIndex('Route')"
    }],
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', [_c('div', {
    staticClass: "el-input el-input-group el-input-group--prepend"
  }, [_c('a', {
    staticClass: "el-input-group__prepend el-button el-icon-close",
    on: {
      "click": function($event) {
        _vm.removeIndex('Route', true)
      }
    }
  }), _vm._v(" "), _c('el-select', {
    attrs: {
      "placeholder": _vm.$t('SELECTROUTE'),
      "filterable": "",
      "clearable": _vm.filters[_vm.filterKey].TourID ? true : false
    },
    model: {
      value: (_vm.filters[_vm.filterKey].TourID),
      callback: function($$v) {
        _vm.$set(_vm.filters[_vm.filterKey], "TourID", $$v)
      },
      expression: "filters[filterKey].TourID"
    }
  }, _vm._l((_vm.routes), function(route, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "label": route.TourName,
        "value": route.TourID
      }
    })
  }))], 1)])], 1), _vm._v(" "), _c('el-col', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.checkIndex('Bus')),
      expression: "checkIndex('Bus')"
    }],
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', [_c('div', {
    staticClass: "el-input el-input-group el-input-group--prepend"
  }, [_c('a', {
    staticClass: "el-input-group__prepend el-button el-icon-close",
    on: {
      "click": function($event) {
        _vm.removeIndex('Bus', true)
      }
    }
  }), _vm._v(" "), _c('el-select', {
    attrs: {
      "placeholder": _vm.$t('SELECTBUS'),
      "filterable": "",
      "clearable": _vm.filters[_vm.filterKey].BusID ? true : false
    },
    model: {
      value: (_vm.filters[_vm.filterKey].BusID),
      callback: function($$v) {
        _vm.$set(_vm.filters[_vm.filterKey], "BusID", $$v)
      },
      expression: "filters[filterKey].BusID"
    }
  }, _vm._l((_vm.buses), function(bus, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "label": bus.Label,
        "value": bus.BusID
      }
    })
  }))], 1)])], 1), _vm._v(" "), _c('el-col', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.dateRangeAccess()),
      expression: "dateRangeAccess()"
    }],
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', [_c('div', {
    staticClass: "el-input el-input-group el-input-group--prepend"
  }, [_c('a', {
    staticClass: "el-input-group__prepend el-button el-icon-close",
    on: {
      "click": function($event) {
        _vm.removeIndex('dateRange', true)
      }
    }
  }), _vm._v(" "), _c('el-date-picker', {
    attrs: {
      "picker-options": _vm.pickerOption,
      "type": "daterange",
      "placeholder": _vm.$t('PICKARANGE')
    },
    on: {
      "onClick": function($event) {
        _vm.resetFiltersValue()
      }
    },
    model: {
      value: (_vm.filters[_vm.filterKey].dateRange),
      callback: function($$v) {
        _vm.$set(_vm.filters[_vm.filterKey], "dateRange", $$v)
      },
      expression: "filters[filterKey].dateRange"
    }
  })], 1)])], 1)], 1)], 1)], 1)], 1), _vm._v(" "), (_vm.filterKey === 'Supervisor') ? _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    style: ({
      opacity: _vm.opacity[_vm.filterKey],
      height: _vm.loadHeight + 'px'
    }),
    attrs: {
      "id": "load-panel",
      "element-loading-text": _vm.$t('LOADING')
    }
  }, [_c('el-table', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.groupBy[_vm.filterKey] && _vm.CountDataColumn[_vm.filterKey].length == 0),
      expression: "!groupBy[filterKey] && CountDataColumn[filterKey].length == 0"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.filteredData[_vm.filterKey][_vm.currentPage[_vm.filterKey] - 1],
      "height": _vm.tableHeight,
      "highlight-current-row": "",
      "empty-text": _vm.$t('NODATATOSHOW'),
      "stripe": ""
    }
  }, _vm._l((_vm.makeList(_vm.dataColumns[_vm.filterKey], true)), function(item, key) {
    return (_vm.DataColumn[_vm.filterKey].indexOf(key) >= 0) ? _c('el-table-column', {
      key: key,
      attrs: {
        "label": item,
        "align": "left"
      },
      scopedSlots: _vm._u([{
        key: "default",
        fn: function(scope) {
          return [_vm._v(_vm._s(scope.row[key]))]
        }
      }])
    }) : _vm._e()
  })), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.groupBy[_vm.filterKey] || _vm.CountDataColumn[_vm.filterKey].length > 0),
      expression: "groupBy[filterKey] || CountDataColumn[filterKey].length > 0"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.filteredCountData[_vm.filterKey][_vm.currentPage[_vm.filterKey] - 1],
      "highlight-current-row": "",
      "empty-text": _vm.$t('NODATATOSHOW'),
      "height": _vm.tableHeight,
      "stripe": ""
    }
  }, [_vm._l((_vm.makeList(_vm.countDataColumns[_vm.filterKey], true, true)), function(item, key) {
    return (!_vm.groupBy[_vm.filterKey] && (_vm.CountDataColumn[_vm.filterKey].indexOf(key) >= 0 || key == 'Count')) ? _c('el-table-column', {
      key: key,
      attrs: {
        "label": item,
        "align": "left"
      },
      scopedSlots: _vm._u([{
        key: "default",
        fn: function(scope) {
          return [_vm._v(_vm._s(scope.row[key]))]
        }
      }])
    }) : _vm._e()
  }), _vm._v(" "), _vm._l((_vm.makeList(_vm.countDataColumns[_vm.filterKey], true, true)), function(item, key) {
    return (_vm.groupBy[_vm.filterKey] && _vm.DataColumn[_vm.filterKey].indexOf(key) >= 0) ? _c('el-table-column', {
      key: key,
      attrs: {
        "label": item,
        "align": "left"
      },
      scopedSlots: _vm._u([{
        key: "default",
        fn: function(scope) {
          return [_vm._v(_vm._s(scope.row[key]))]
        }
      }])
    }) : _vm._e()
  })], 2), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.checkAllConditions()),
      expression: "checkAllConditions()"
    }],
    staticClass: "footer"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.filteredData[_vm.filterKey].length != 0),
      expression: "filteredData[filterKey].length!=0"
    }],
    staticStyle: {
      "float": "left"
    }
  }, [_c('el-select', {
    ref: "countsBy",
    staticClass: "autoWidth",
    attrs: {
      "size": "small",
      "disabled": !(!_vm.groupBy[_vm.filterKey] && _vm.filteredData[_vm.filterKey].length != 0),
      "placeholder": _vm.$t('UNIQUECOUNTBY'),
      "multiple": ""
    },
    on: {
      "change": _vm.uniqueColumnsCount
    },
    model: {
      value: (_vm.CountDataColumn[_vm.filterKey]),
      callback: function($$v) {
        _vm.$set(_vm.CountDataColumn, _vm.filterKey, $$v)
      },
      expression: "CountDataColumn[filterKey]"
    }
  }, _vm._l((_vm.makeList(_vm.countDataColumns[_vm.filterKey], true, true)), function(item, key) {
    return (_vm.DataColumn[_vm.filterKey].indexOf(key) >= 0) ? _c('el-option', {
      key: key,
      attrs: {
        "label": item,
        "value": key
      }
    }) : _vm._e()
  }))], 1), _vm._v(" "), _c('el-pagination', {
    attrs: {
      "current-page": _vm.currentPage[_vm.filterKey],
      "page-sizes": [20, 30, 50, 70],
      "page-size": _vm.limit[_vm.filterKey],
      "layout": "total, sizes, prev, pager, next",
      "total": _vm.total[_vm.filterKey]
    },
    on: {
      "size-change": _vm.handleSizeChange,
      "current-change": _vm.handleCurrentChange
    }
  })], 1)], 1) : _vm._e()], 2), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": _vm.$tc('DRIVER', 1),
      "name": "Driver"
    }
  }, [_vm._l((_vm.DataColumn[_vm.filterKey]), function(item, index) {
    return _c('div', {
      key: index
    })
  }), _vm._v(" "), _c('el-row', {
    staticClass: "filters",
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": _vm.$t('FILTERBYDRIVER'),
      "clearable": _vm.filterBy[_vm.filterKey][0] ? true : false
    },
    on: {
      "change": _vm.resetFiltersValue
    },
    model: {
      value: (_vm.filterBy[_vm.filterKey][0]),
      callback: function($$v) {
        _vm.$set(_vm.filterBy[_vm.filterKey], 0, $$v)
      },
      expression: "filterBy[filterKey][0]"
    }
  }, _vm._l((_vm.makeList(_vm.mainTypes[_vm.filterKey])), function(item, key) {
    return _c('el-option', {
      key: key,
      attrs: {
        "label": item,
        "value": key
      }
    })
  }))], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 14
    }
  }, [_c('el-form', {
    ref: "form",
    attrs: {
      "id": "driverFilters",
      "model": _vm.filters[_vm.filterKey]
    }
  }, [_c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.checkIndex('Nationality')),
      expression: "checkIndex('Nationality')"
    }],
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', [_c('div', {
    staticClass: "el-input el-input-group el-input-group--prepend"
  }, [_c('a', {
    staticClass: "el-input-group__prepend el-button el-icon-close",
    on: {
      "click": function($event) {
        _vm.removeIndex('Nationality', true)
      }
    }
  }), _vm._v(" "), _c('el-select', {
    attrs: {
      "placeholder": _vm.$t('SELECTNATIONALITY'),
      "filterable": "",
      "clearable": _vm.filters[_vm.filterKey].Nationality ? true : false
    },
    model: {
      value: (_vm.filters[_vm.filterKey].Nationality),
      callback: function($$v) {
        _vm.$set(_vm.filters[_vm.filterKey], "Nationality", $$v)
      },
      expression: "filters[filterKey].Nationality"
    }
  }, _vm._l((_vm.$countries), function(item, key) {
    return _c('el-option', {
      key: key,
      attrs: {
        "label": item,
        "value": key
      }
    })
  }))], 1)])], 1), _vm._v(" "), _c('el-col', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.checkIndex('Route')),
      expression: "checkIndex('Route')"
    }],
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', [_c('div', {
    staticClass: "el-input el-input-group el-input-group--prepend"
  }, [_c('a', {
    staticClass: "el-input-group__prepend el-button el-icon-close",
    on: {
      "click": function($event) {
        _vm.removeIndex('Route', true)
      }
    }
  }), _vm._v(" "), _c('el-select', {
    attrs: {
      "placeholder": _vm.$t('SELECTROUTE'),
      "filterable": "",
      "clearable": _vm.filters[_vm.filterKey].TourID ? true : false
    },
    model: {
      value: (_vm.filters[_vm.filterKey].TourID),
      callback: function($$v) {
        _vm.$set(_vm.filters[_vm.filterKey], "TourID", $$v)
      },
      expression: "filters[filterKey].TourID"
    }
  }, _vm._l((_vm.routes), function(route, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "label": route.TourName,
        "value": route.TourID
      }
    })
  }))], 1)])], 1), _vm._v(" "), _c('el-col', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.checkIndex('Bus')),
      expression: "checkIndex('Bus')"
    }],
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', [_c('div', {
    staticClass: "el-input el-input-group el-input-group--prepend"
  }, [_c('a', {
    staticClass: "el-input-group__prepend el-button el-icon-close",
    on: {
      "click": function($event) {
        _vm.removeIndex('Bus', true)
      }
    }
  }), _vm._v(" "), _c('el-select', {
    attrs: {
      "placeholder": _vm.$t('SELECTBUS'),
      "filterable": "",
      "clearable": _vm.filters[_vm.filterKey].BusID ? true : false
    },
    model: {
      value: (_vm.filters[_vm.filterKey].BusID),
      callback: function($$v) {
        _vm.$set(_vm.filters[_vm.filterKey], "BusID", $$v)
      },
      expression: "filters[filterKey].BusID"
    }
  }, _vm._l((_vm.buses), function(bus, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "label": bus.Label,
        "value": bus.BusID
      }
    })
  }))], 1)])], 1), _vm._v(" "), _c('el-col', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.checkIndex('Violation')),
      expression: "checkIndex('Violation')"
    }],
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', [_c('div', {
    staticClass: "el-input el-input-group el-input-group--prepend"
  }, [_c('a', {
    staticClass: "el-input-group__prepend el-button el-icon-close",
    on: {
      "click": function($event) {
        _vm.removeIndex('Violation', true)
      }
    }
  }), _vm._v(" "), _c('el-select', {
    attrs: {
      "placeholder": _vm.$t('SELECTVIOLATION'),
      "clearable": _vm.filters[_vm.filterKey].ViolationTypeID ? true : false
    },
    model: {
      value: (_vm.filters[_vm.filterKey].ViolationTypeID),
      callback: function($$v) {
        _vm.$set(_vm.filters[_vm.filterKey], "ViolationTypeID", $$v)
      },
      expression: "filters[filterKey].ViolationTypeID"
    }
  }, _vm._l((_vm.violations), function(violation, key) {
    return _c('el-option', {
      key: key,
      attrs: {
        "label": violation,
        "value": key
      }
    })
  }))], 1)])], 1), _vm._v(" "), _c('el-col', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.dateRangeAccess()),
      expression: "dateRangeAccess()"
    }],
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', [_c('div', {
    staticClass: "el-input el-input-group el-input-group--prepend"
  }, [_c('a', {
    staticClass: "el-input-group__prepend el-button el-icon-close",
    on: {
      "click": function($event) {
        _vm.removeIndex('dateRange', true)
      }
    }
  }), _vm._v(" "), _c('el-date-picker', {
    attrs: {
      "type": "daterange",
      "picker-options": _vm.pickerOption,
      "placeholder": _vm.$t('PICKARANGE')
    },
    on: {
      "onClick": function($event) {
        _vm.resetFiltersValue()
      }
    },
    model: {
      value: (_vm.filters[_vm.filterKey].dateRange),
      callback: function($$v) {
        _vm.$set(_vm.filters[_vm.filterKey], "dateRange", $$v)
      },
      expression: "filters[filterKey].dateRange"
    }
  })], 1)])], 1)], 1)], 1)], 1)], 1), _vm._v(" "), (_vm.filterKey === 'Driver') ? _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    style: ({
      opacity: _vm.opacity[_vm.filterKey],
      height: _vm.loadHeight + 'px'
    }),
    attrs: {
      "id": "load-panel",
      "element-loading-text": _vm.$t('LOADING')
    }
  }, [_c('el-table', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.groupBy[_vm.filterKey] && _vm.CountDataColumn[_vm.filterKey].length == 0),
      expression: "!groupBy[filterKey] && CountDataColumn[filterKey].length == 0"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.filteredData[_vm.filterKey][_vm.currentPage[_vm.filterKey] - 1],
      "height": _vm.tableHeight,
      "highlight-current-row": "",
      "empty-text": _vm.$t('NODATATOSHOW'),
      "stripe": ""
    }
  }, _vm._l((_vm.makeList(_vm.dataColumns[_vm.filterKey], true)), function(item, key) {
    return (_vm.DataColumn[_vm.filterKey].indexOf(key) >= 0) ? _c('el-table-column', {
      key: key,
      attrs: {
        "label": item,
        "align": "left"
      },
      scopedSlots: _vm._u([{
        key: "default",
        fn: function(scope) {
          return [_vm._v(_vm._s(scope.row[key]))]
        }
      }])
    }) : _vm._e()
  })), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.groupBy[_vm.filterKey] || _vm.CountDataColumn[_vm.filterKey].length > 0),
      expression: "groupBy[filterKey] || CountDataColumn[filterKey].length > 0"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.filteredCountData[_vm.filterKey][_vm.currentPage[_vm.filterKey] - 1],
      "highlight-current-row": "",
      "empty-text": _vm.$t('NODATATOSHOW'),
      "height": _vm.tableHeight,
      "stripe": ""
    }
  }, [_vm._l((_vm.makeList(_vm.countDataColumns[_vm.filterKey], true, true)), function(item, key) {
    return (!_vm.groupBy[_vm.filterKey] && (_vm.CountDataColumn[_vm.filterKey].indexOf(key) >= 0 || key == 'Count')) ? _c('el-table-column', {
      key: key,
      attrs: {
        "label": item,
        "align": "left"
      },
      scopedSlots: _vm._u([{
        key: "default",
        fn: function(scope) {
          return [_vm._v(_vm._s(scope.row[key]))]
        }
      }])
    }) : _vm._e()
  }), _vm._v(" "), _vm._l((_vm.makeList(_vm.countDataColumns[_vm.filterKey], true, true)), function(item, key) {
    return (_vm.groupBy[_vm.filterKey] && _vm.DataColumn[_vm.filterKey].indexOf(key) >= 0) ? _c('el-table-column', {
      key: key,
      attrs: {
        "label": item,
        "align": "left"
      },
      scopedSlots: _vm._u([{
        key: "default",
        fn: function(scope) {
          return [_vm._v(_vm._s(scope.row[key]))]
        }
      }])
    }) : _vm._e()
  })], 2), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.checkAllConditions()),
      expression: "checkAllConditions()"
    }],
    staticClass: "footer"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.filteredData[_vm.filterKey].length != 0),
      expression: "filteredData[filterKey].length!=0"
    }],
    staticStyle: {
      "float": "left"
    }
  }, [_c('el-select', {
    ref: "countsBy",
    staticClass: "autoWidth",
    attrs: {
      "size": "small",
      "disabled": !(!_vm.groupBy[_vm.filterKey] && _vm.filteredData[_vm.filterKey].length != 0),
      "placeholder": _vm.$t('UNIQUECOUNTBY'),
      "multiple": ""
    },
    on: {
      "change": _vm.uniqueColumnsCount
    },
    model: {
      value: (_vm.CountDataColumn[_vm.filterKey]),
      callback: function($$v) {
        _vm.$set(_vm.CountDataColumn, _vm.filterKey, $$v)
      },
      expression: "CountDataColumn[filterKey]"
    }
  }, _vm._l((_vm.makeList(_vm.countDataColumns[_vm.filterKey], true, true)), function(item, key) {
    return (_vm.DataColumn[_vm.filterKey].indexOf(key) >= 0) ? _c('el-option', {
      key: key,
      attrs: {
        "label": item,
        "value": key
      }
    }) : _vm._e()
  }))], 1), _vm._v(" "), _c('el-pagination', {
    attrs: {
      "current-page": _vm.currentPage[_vm.filterKey],
      "page-sizes": [20, 30, 50, 70],
      "page-size": _vm.limit[_vm.filterKey],
      "layout": "total, sizes, prev, pager, next",
      "total": _vm.total[_vm.filterKey]
    },
    on: {
      "size-change": _vm.handleSizeChange,
      "current-change": _vm.handleCurrentChange
    }
  })], 1)], 1) : _vm._e()], 2), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": _vm.$t('INCIDENT'),
      "name": "Incident"
    }
  }, [_vm._l((_vm.DataColumn[_vm.filterKey]), function(item, index) {
    return _c('div', {
      key: index
    })
  }), _vm._v(" "), _c('el-row', {
    staticClass: "filters",
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": _vm.$t('FILTERBYINCIDENT'),
      "multiple": ""
    },
    on: {
      "change": _vm.resetFiltersValue,
      "handleOptionClick": _vm.handleGroupedOption,
      "remove-tag": _vm.removeTag
    },
    model: {
      value: (_vm.conditionalFilterBy),
      callback: function($$v) {
        _vm.conditionalFilterBy = $$v
      },
      expression: "conditionalFilterBy"
    }
  }, [_c('el-option-group', {
    attrs: {
      "label": _vm.$t('SELECTONE')
    }
  }, _vm._l((_vm.makeList(_vm.mainTypes[_vm.filterKey])), function(item, key, index) {
    return (index < 3) ? _c('el-option', {
      key: index,
      attrs: {
        "label": item,
        "value": key
      }
    }) : _vm._e()
  })), _vm._v(" "), _c('el-option-group', {
    attrs: {
      "label": _vm.$t('SELECTMULTIPLE')
    }
  }, _vm._l((_vm.makeList(_vm.mainTypes[_vm.filterKey])), function(item, key, index) {
    return (index >= 3) ? _c('el-option', {
      key: index,
      attrs: {
        "label": item,
        "value": key
      }
    }) : _vm._e()
  }))], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 16
    }
  }, [_c('el-form', {
    ref: "form",
    attrs: {
      "id": "incidentFilters",
      "model": _vm.filters[_vm.filterKey]
    }
  }, [_c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.checkIndex('Driver')),
      expression: "checkIndex('Driver')"
    }],
    attrs: {
      "span": _vm.getDynamicSpan()
    }
  }, [_c('el-form-item', [_c('div', {
    staticClass: "el-input el-input-group el-input-group--prepend"
  }, [_c('a', {
    staticClass: "el-input-group__prepend el-button el-icon-close",
    on: {
      "click": function($event) {
        _vm.removeIndex('Driver', true)
      }
    }
  }), _vm._v(" "), _c('el-select', {
    attrs: {
      "placeholder": _vm.$t('SELECTDRIVER'),
      "filterable": "",
      "clearable": _vm.filters[_vm.filterKey].BusDriverID ? true : false
    },
    model: {
      value: (_vm.filters[_vm.filterKey].BusDriverID),
      callback: function($$v) {
        _vm.$set(_vm.filters[_vm.filterKey], "BusDriverID", $$v)
      },
      expression: "filters[filterKey].BusDriverID"
    }
  }, _vm._l((_vm.drivers), function(driver, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "label": _vm._FullName({
          NameEN: driver.FullName_EN,
          NameAR: driver.FullName_AR
        }),
        "value": driver.BusDriverID
      }
    })
  }))], 1)])], 1), _vm._v(" "), _c('el-col', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.checkIndex('Supervisor')),
      expression: "checkIndex('Supervisor')"
    }],
    attrs: {
      "span": _vm.getDynamicSpan()
    }
  }, [_c('el-form-item', [_c('div', {
    staticClass: "el-input el-input-group el-input-group--prepend"
  }, [_c('a', {
    staticClass: "el-input-group__prepend el-button el-icon-close",
    on: {
      "click": function($event) {
        _vm.removeIndex('Supervisor', true)
      }
    }
  }), _vm._v(" "), _c('el-select', {
    attrs: {
      "placeholder": _vm.$t('SELECTSUPERVISOR'),
      "filterable": "",
      "clearable": _vm.filters[_vm.filterKey].BusMonitorID ? true : false
    },
    model: {
      value: (_vm.filters[_vm.filterKey].BusMonitorID),
      callback: function($$v) {
        _vm.$set(_vm.filters[_vm.filterKey], "BusMonitorID", $$v)
      },
      expression: "filters[filterKey].BusMonitorID"
    }
  }, _vm._l((_vm.monitors), function(monitor, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "label": _vm._FullName({
          NameEN: monitor.FullName_EN,
          NameAR: monitor.FullName_AR
        }),
        "value": monitor.BusMonitorID
      }
    })
  }))], 1)])], 1), _vm._v(" "), _c('el-col', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.checkIndex('Bus')),
      expression: "checkIndex('Bus')"
    }],
    attrs: {
      "span": _vm.getDynamicSpan()
    }
  }, [_c('el-form-item', [_c('div', {
    staticClass: "el-input el-input-group el-input-group--prepend"
  }, [_c('a', {
    staticClass: "el-input-group__prepend el-button el-icon-close",
    on: {
      "click": function($event) {
        _vm.removeIndex('Bus', true)
      }
    }
  }), _vm._v(" "), _c('el-select', {
    attrs: {
      "placeholder": _vm.$t('SELECTBUS'),
      "filterable": "",
      "clearable": _vm.filters[_vm.filterKey].BusID ? true : false
    },
    model: {
      value: (_vm.filters[_vm.filterKey].BusID),
      callback: function($$v) {
        _vm.$set(_vm.filters[_vm.filterKey], "BusID", $$v)
      },
      expression: "filters[filterKey].BusID"
    }
  }, _vm._l((_vm.buses), function(bus, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "label": bus.Label,
        "value": bus.BusID
      }
    })
  }))], 1)])], 1), _vm._v(" "), _c('el-col', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.checkIndex('Type')),
      expression: "checkIndex('Type')"
    }],
    attrs: {
      "span": _vm.getDynamicSpan()
    }
  }, [_c('el-form-item', [_c('div', {
    staticClass: "el-input el-input-group el-input-group--prepend"
  }, [_c('a', {
    staticClass: "el-input-group__prepend el-button el-icon-close",
    on: {
      "click": function($event) {
        _vm.removeIndex('Type', true)
      }
    }
  }), _vm._v(" "), _c('el-select', {
    attrs: {
      "placeholder": _vm.$t('SELECTTYPE'),
      "clearable": _vm.filters[_vm.filterKey].IncidentTypeID ? true : false
    },
    model: {
      value: (_vm.filters[_vm.filterKey].IncidentTypeID),
      callback: function($$v) {
        _vm.$set(_vm.filters[_vm.filterKey], "IncidentTypeID", $$v)
      },
      expression: "filters[filterKey].IncidentTypeID"
    }
  }, _vm._l((_vm.incidents), function(incident, key) {
    return _c('el-option', {
      key: key,
      attrs: {
        "label": incident,
        "value": key
      }
    })
  }))], 1)])], 1), _vm._v(" "), _c('el-col', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.checkIndex('Status')),
      expression: "checkIndex('Status')"
    }],
    attrs: {
      "span": _vm.getDynamicSpan()
    }
  }, [_c('el-form-item', [_c('div', {
    staticClass: "el-input el-input-group el-input-group--prepend"
  }, [_c('a', {
    staticClass: "el-input-group__prepend el-button el-icon-close",
    on: {
      "click": function($event) {
        _vm.removeIndex('Status', true)
      }
    }
  }), _vm._v(" "), _c('el-select', {
    attrs: {
      "placeholder": _vm.$t('SELECTSTATUS'),
      "clearable": _vm.filters[_vm.filterKey].Status ? true : false
    },
    model: {
      value: (_vm.filters[_vm.filterKey].Status),
      callback: function($$v) {
        _vm.$set(_vm.filters[_vm.filterKey], "Status", $$v)
      },
      expression: "filters[filterKey].Status"
    }
  }, _vm._l((_vm.Statuses), function(status, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "label": status,
        "value": status
      }
    })
  }))], 1)])], 1), _vm._v(" "), _c('el-col', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.dateRangeAccess()),
      expression: "dateRangeAccess()"
    }],
    attrs: {
      "span": _vm.getDynamicSpan()
    }
  }, [_c('el-form-item', [_c('div', {
    staticClass: "el-input el-input-group el-input-group--prepend"
  }, [_c('a', {
    staticClass: "el-input-group__prepend el-button el-icon-close",
    on: {
      "click": function($event) {
        _vm.removeIndex('dateRange', true)
      }
    }
  }), _vm._v(" "), _c('el-date-picker', {
    attrs: {
      "type": "daterange",
      "picker-options": _vm.pickerOption,
      "placeholder": _vm.$t('PICKARANGE')
    },
    on: {
      "onClick": function($event) {
        _vm.resetFiltersValue()
      }
    },
    model: {
      value: (_vm.filters[_vm.filterKey].dateRange),
      callback: function($$v) {
        _vm.$set(_vm.filters[_vm.filterKey], "dateRange", $$v)
      },
      expression: "filters[filterKey].dateRange"
    }
  })], 1)])], 1)], 1)], 1)], 1)], 1), _vm._v(" "), (_vm.filterKey === 'Incident') ? _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    style: ({
      opacity: _vm.opacity[_vm.filterKey],
      height: _vm.loadHeight + 'px'
    }),
    attrs: {
      "id": "load-panel",
      "element-loading-text": _vm.$t('LOADING')
    }
  }, [_c('el-table', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.groupBy[_vm.filterKey] && _vm.CountDataColumn[_vm.filterKey].length == 0),
      expression: "!groupBy[filterKey] && CountDataColumn[filterKey].length == 0"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.filteredData[_vm.filterKey][_vm.currentPage[_vm.filterKey] - 1],
      "height": _vm.tableHeight,
      "highlight-current-row": "",
      "empty-text": _vm.$t('NODATATOSHOW'),
      "stripe": ""
    }
  }, _vm._l((_vm.makeList(_vm.dataColumns[_vm.filterKey], true)), function(item, key) {
    return (_vm.DataColumn[_vm.filterKey].indexOf(key) >= 0) ? _c('el-table-column', {
      key: key,
      attrs: {
        "label": item,
        "align": "left"
      },
      scopedSlots: _vm._u([{
        key: "default",
        fn: function(scope) {
          return [_vm._v(_vm._s(scope.row[key]))]
        }
      }])
    }) : _vm._e()
  })), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.groupBy[_vm.filterKey] || _vm.CountDataColumn[_vm.filterKey].length > 0),
      expression: "groupBy[filterKey] || CountDataColumn[filterKey].length > 0"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.filteredCountData[_vm.filterKey][_vm.currentPage[_vm.filterKey] - 1],
      "highlight-current-row": "",
      "empty-text": _vm.$t('NODATATOSHOW'),
      "height": _vm.tableHeight,
      "stripe": ""
    }
  }, [_vm._l((_vm.makeList(_vm.countDataColumns[_vm.filterKey], true, true)), function(item, key) {
    return (!_vm.groupBy[_vm.filterKey] && (_vm.CountDataColumn[_vm.filterKey].indexOf(key) >= 0 || key == 'Count')) ? _c('el-table-column', {
      key: key,
      attrs: {
        "label": item,
        "align": "left"
      },
      scopedSlots: _vm._u([{
        key: "default",
        fn: function(scope) {
          return [_vm._v(_vm._s(scope.row[key]))]
        }
      }])
    }) : _vm._e()
  }), _vm._v(" "), _vm._l((_vm.makeList(_vm.countDataColumns[_vm.filterKey], true, true)), function(item, key) {
    return (_vm.groupBy[_vm.filterKey] && _vm.DataColumn[_vm.filterKey].indexOf(key) >= 0) ? _c('el-table-column', {
      key: key,
      attrs: {
        "label": item,
        "align": "left"
      },
      scopedSlots: _vm._u([{
        key: "default",
        fn: function(scope) {
          return [_vm._v(_vm._s(scope.row[key]))]
        }
      }])
    }) : _vm._e()
  })], 2), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.checkAllConditions()),
      expression: "checkAllConditions()"
    }],
    staticClass: "footer"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.filteredData[_vm.filterKey].length != 0),
      expression: "filteredData[filterKey].length!=0"
    }],
    staticStyle: {
      "float": "left"
    }
  }, [_c('el-select', {
    ref: "countsBy",
    staticClass: "autoWidth",
    attrs: {
      "size": "small",
      "disabled": !(!_vm.groupBy[_vm.filterKey] && _vm.filteredData[_vm.filterKey].length != 0),
      "placeholder": _vm.$t('UNIQUECOUNTBY'),
      "multiple": ""
    },
    on: {
      "change": _vm.uniqueColumnsCount
    },
    model: {
      value: (_vm.CountDataColumn[_vm.filterKey]),
      callback: function($$v) {
        _vm.$set(_vm.CountDataColumn, _vm.filterKey, $$v)
      },
      expression: "CountDataColumn[filterKey]"
    }
  }, _vm._l((_vm.makeList(_vm.countDataColumns[_vm.filterKey], true, true)), function(item, key) {
    return (_vm.DataColumn[_vm.filterKey].indexOf(key) >= 0) ? _c('el-option', {
      key: key,
      attrs: {
        "label": item,
        "value": key
      }
    }) : _vm._e()
  }))], 1), _vm._v(" "), _c('el-pagination', {
    attrs: {
      "current-page": _vm.currentPage[_vm.filterKey],
      "page-sizes": [20, 30, 50, 70],
      "page-size": _vm.limit[_vm.filterKey],
      "layout": "total, sizes, prev, pager, next",
      "total": _vm.total[_vm.filterKey]
    },
    on: {
      "size-change": _vm.handleSizeChange,
      "current-change": _vm.handleCurrentChange
    }
  })], 1)], 1) : _vm._e()], 2), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": _vm.$t('STUDENTS'),
      "name": "Student"
    }
  }, [_vm._l((_vm.DataColumn[_vm.filterKey]), function(item, index) {
    return _c('div', {
      key: index
    })
  }), _vm._v(" "), _c('el-row', {
    staticClass: "filters",
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": _vm.$t('FILTERBYSTUDENT'),
      "multiple": ""
    },
    on: {
      "change": _vm.resetFiltersValue,
      "handleOptionClick": _vm.handleGroupedOption,
      "remove-tag": _vm.removeTag
    },
    model: {
      value: (_vm.conditionalFilterBy),
      callback: function($$v) {
        _vm.conditionalFilterBy = $$v
      },
      expression: "conditionalFilterBy"
    }
  }, [_c('el-option-group', {
    attrs: {
      "label": _vm.$t('SELECTONE')
    }
  }, _vm._l((_vm.makeList(_vm.mainTypes[_vm.filterKey])), function(item, key, index) {
    return (index < 3) ? _c('el-option', {
      key: index,
      attrs: {
        "label": item,
        "value": key
      }
    }) : _vm._e()
  })), _vm._v(" "), _c('el-option-group', {
    attrs: {
      "label": _vm.$t('SELECTMULTIPLE')
    }
  }, _vm._l((_vm.makeList(_vm.mainTypes[_vm.filterKey])), function(item, key, index) {
    return (index >= 3) ? _c('el-option', {
      key: index,
      attrs: {
        "label": item,
        "value": key
      }
    }) : _vm._e()
  }))], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 16
    }
  }, [_c('el-form', {
    ref: "form",
    attrs: {
      "id": "studentFilters",
      "model": _vm.filters[_vm.filterKey]
    }
  }, [_c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.checkIndex('Absence')),
      expression: "checkIndex('Absence')"
    }],
    attrs: {
      "span": 16
    }
  }, [_c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 10
    }
  }, [_c('el-form-item', [_c('div', {
    staticClass: "el-input el-input-group el-input-group--prepend"
  }, [_c('a', {
    staticClass: "el-input-group__prepend el-button el-icon-close",
    on: {
      "click": function($event) {
        _vm.removeIndex('Absence', true)
      }
    }
  }), _vm._v(" "), _c('el-select', {
    attrs: {
      "placeholder": _vm.$t('SELECTREASON'),
      "clearable": _vm.filters[_vm.filterKey].Reason ? true : false
    },
    model: {
      value: (_vm.filters[_vm.filterKey].Reason),
      callback: function($$v) {
        _vm.$set(_vm.filters[_vm.filterKey], "Reason", $$v)
      },
      expression: "filters[filterKey].Reason"
    }
  }, _vm._l((_vm.reasons), function(reason, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "label": reason,
        "value": reason
      }
    })
  }))], 1)])], 1), _vm._v(" "), _c('el-col', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.dateRangeAccess()),
      expression: "dateRangeAccess()"
    }],
    attrs: {
      "span": 14
    }
  }, [_c('el-form-item', [_c('div', {
    staticClass: "el-input el-input-group el-input-group--prepend"
  }, [_c('a', {
    staticClass: "el-input-group__prepend el-button el-icon-close",
    on: {
      "click": function($event) {
        _vm.removeIndex('dateRange', true)
      }
    }
  }), _vm._v(" "), _c('el-date-picker', {
    attrs: {
      "type": "daterange",
      "picker-options": _vm.pickerOption,
      "placeholder": _vm.$t('PICKARANGE')
    },
    model: {
      value: (_vm.filters[_vm.filterKey].dateRange),
      callback: function($$v) {
        _vm.$set(_vm.filters[_vm.filterKey], "dateRange", $$v)
      },
      expression: "filters[filterKey].dateRange"
    }
  })], 1)])], 1)], 1)], 1), _vm._v(" "), _c('el-col', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.checkIndex('Address')),
      expression: "checkIndex('Address')"
    }],
    attrs: {
      "span": 16
    }
  }, [_c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 16
    }
  }, [_c('el-form-item', [_c('div', {
    staticClass: "el-input el-input-group el-input-group--prepend"
  }, [_c('a', {
    staticClass: "el-input-group__prepend el-button el-icon-close",
    on: {
      "click": function($event) {
        _vm.removeIndex('Address', true)
      }
    }
  }), _vm._v(" "), _c('input', {
    staticClass: "el-input__inner",
    attrs: {
      "type": "text",
      "placeholder": _vm.$t('SEARCHADDRESS'),
      "id": "location",
      "autocomplete": "off"
    }
  })])])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('el-form-item', [_c('el-input', {
    attrs: {
      "type": "number",
      "placeholder": "Range",
      "step": 0.5
    },
    model: {
      value: (_vm.filters[_vm.filterKey].radius),
      callback: function($$v) {
        _vm.$set(_vm.filters[_vm.filterKey], "radius", $$v)
      },
      expression: "filters[filterKey].radius"
    }
  }, [_c('template', {
    slot: "append"
  }, [_vm._v(_vm._s(_vm.$t('KM')))])], 2)], 1)], 1)], 1)], 1), _vm._v(" "), _c('el-col', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.checkIndex('Bus')),
      expression: "checkIndex('Bus')"
    }],
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', [_c('div', {
    staticClass: "el-input el-input-group el-input-group--prepend"
  }, [_c('a', {
    staticClass: "el-input-group__prepend el-button el-icon-close",
    on: {
      "click": function($event) {
        _vm.removeIndex('Bus', true)
      }
    }
  }), _vm._v(" "), _c('el-select', {
    attrs: {
      "placeholder": _vm.$t('SELECTBUS'),
      "filterable": "",
      "clearable": _vm.filters[_vm.filterKey].BusID ? true : false
    },
    model: {
      value: (_vm.filters[_vm.filterKey].BusID),
      callback: function($$v) {
        _vm.$set(_vm.filters[_vm.filterKey], "BusID", $$v)
      },
      expression: "filters[filterKey].BusID"
    }
  }, _vm._l((_vm.buses), function(bus, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "label": bus.Label,
        "value": bus.BusID
      }
    })
  }))], 1)])], 1), _vm._v(" "), _c('el-col', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.checkIndex('Grade')),
      expression: "checkIndex('Grade')"
    }],
    attrs: {
      "span": 8
    }
  }, [_c('el-form-item', [_c('div', {
    staticClass: "el-input el-input-group el-input-group--prepend"
  }, [_c('a', {
    staticClass: "el-input-group__prepend el-button el-icon-close",
    on: {
      "click": function($event) {
        _vm.removeIndex('Grade', true)
      }
    }
  }), _vm._v(" "), _c('el-select', {
    attrs: {
      "placeholder": _vm.$t('SELECTGRADE'),
      "filterable": "",
      "clearable": _vm.filters[_vm.filterKey].Grade ? true : false
    },
    model: {
      value: (_vm.filters[_vm.filterKey].Grade),
      callback: function($$v) {
        _vm.$set(_vm.filters[_vm.filterKey], "Grade", $$v)
      },
      expression: "filters[filterKey].Grade"
    }
  }, _vm._l((_vm.grades), function(grade, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "label": grade.Name,
        "value": grade.Name
      }
    })
  }))], 1)])], 1)], 1)], 1)], 1)], 1), _vm._v(" "), (_vm.filterKey === 'Student') ? _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    style: ({
      opacity: _vm.opacity[_vm.filterKey],
      height: _vm.loadHeight + 'px'
    }),
    attrs: {
      "id": "load-panel",
      "element-loading-text": _vm.$t('LOADING')
    }
  }, [_c('el-table', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.groupBy[_vm.filterKey] && _vm.CountDataColumn[_vm.filterKey].length == 0),
      expression: "!groupBy[filterKey] && CountDataColumn[filterKey].length == 0"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.filteredData[_vm.filterKey][_vm.currentPage[_vm.filterKey] - 1],
      "height": _vm.tableHeight,
      "highlight-current-row": "",
      "empty-text": _vm.$t('NODATATOSHOW'),
      "stripe": ""
    }
  }, _vm._l((_vm.makeList(_vm.dataColumns[_vm.filterKey], true)), function(item, key) {
    return (_vm.DataColumn[_vm.filterKey].indexOf(key) >= 0) ? _c('el-table-column', {
      key: key,
      attrs: {
        "label": item,
        "align": "left"
      },
      scopedSlots: _vm._u([{
        key: "default",
        fn: function(scope) {
          return [_vm._v(_vm._s(scope.row[key]))]
        }
      }])
    }) : _vm._e()
  })), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.groupBy[_vm.filterKey] || _vm.CountDataColumn[_vm.filterKey].length > 0),
      expression: "groupBy[filterKey] || CountDataColumn[filterKey].length > 0"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.filteredCountData[_vm.filterKey][_vm.currentPage[_vm.filterKey] - 1],
      "highlight-current-row": "",
      "empty-text": _vm.$t('NODATATOSHOW'),
      "height": _vm.tableHeight,
      "stripe": ""
    }
  }, [_vm._l((_vm.makeList(_vm.countDataColumns[_vm.filterKey], true, true)), function(item, key) {
    return (!_vm.groupBy[_vm.filterKey] && (_vm.CountDataColumn[_vm.filterKey].indexOf(key) >= 0 || key == 'Count')) ? _c('el-table-column', {
      key: key,
      attrs: {
        "label": item,
        "align": "left"
      },
      scopedSlots: _vm._u([{
        key: "default",
        fn: function(scope) {
          return [_vm._v(_vm._s(scope.row[key]))]
        }
      }])
    }) : _vm._e()
  }), _vm._v(" "), _vm._l((_vm.makeList(_vm.countDataColumns[_vm.filterKey], true, true)), function(item, key) {
    return (_vm.groupBy[_vm.filterKey] && _vm.DataColumn[_vm.filterKey].indexOf(key) >= 0) ? _c('el-table-column', {
      key: key,
      attrs: {
        "label": item,
        "align": "left"
      },
      scopedSlots: _vm._u([{
        key: "default",
        fn: function(scope) {
          return [_vm._v(_vm._s(scope.row[key]))]
        }
      }])
    }) : _vm._e()
  })], 2), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.checkAllConditions()),
      expression: "checkAllConditions()"
    }],
    staticClass: "footer"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.filteredData[_vm.filterKey].length != 0),
      expression: "filteredData[filterKey].length!=0"
    }],
    staticStyle: {
      "float": "left"
    }
  }, [_c('el-select', {
    ref: "countsBy",
    staticClass: "autoWidth",
    attrs: {
      "size": "small",
      "disabled": !(!_vm.groupBy[_vm.filterKey] && _vm.filteredData[_vm.filterKey].length != 0),
      "placeholder": _vm.$t('UNIQUECOUNTBY'),
      "multiple": ""
    },
    on: {
      "change": _vm.uniqueColumnsCount
    },
    model: {
      value: (_vm.CountDataColumn[_vm.filterKey]),
      callback: function($$v) {
        _vm.$set(_vm.CountDataColumn, _vm.filterKey, $$v)
      },
      expression: "CountDataColumn[filterKey]"
    }
  }, _vm._l((_vm.makeList(_vm.countDataColumns[_vm.filterKey], true, true)), function(item, key) {
    return (_vm.DataColumn[_vm.filterKey].indexOf(key) >= 0) ? _c('el-option', {
      key: key,
      attrs: {
        "label": item,
        "value": key
      }
    }) : _vm._e()
  }))], 1), _vm._v(" "), _c('el-pagination', {
    attrs: {
      "current-page": _vm.currentPage[_vm.filterKey],
      "page-sizes": [20, 30, 50, 70],
      "page-size": _vm.limit[_vm.filterKey],
      "layout": "total, sizes, prev, pager, next",
      "total": _vm.total[_vm.filterKey]
    },
    on: {
      "size-change": _vm.handleSizeChange,
      "current-change": _vm.handleCurrentChange
    }
  })], 1)], 1) : _vm._e()], 2)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-79f98325"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/report/Report.vue
// module id = 617
// module chunks = 1